var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad font14" },
    [
      _c("app-divider", { attrs: { label: "Imóvel" } }),
      _c(
        "div",
        { staticClass: "pad" },
        [
          _c("informacoes-imovel", {
            staticClass: "pad-top",
            attrs: { cadastroOriginal: _vm.cadastroOriginal }
          }),
          _c("informacoes-destinacao-uso-imovel", {
            attrs: { destinacaoUsoImovel: _vm.imovel.destinacaoUsoImovel }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40a3d73c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a3d73c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoImovelBeneficiario.vue
// module id = null
// module chunks = 